<template>
  <div class="bubble"
    :class="{
      from: message.fromTo === 'from',
      to: message.fromTo === 'to',
      ghost: message.disconnect
    }">
    <div class="user" :class="{notranslate: notranslate(message)}">
      <div class="thumb" :class="{custom: customThumb && !(message.fromTo === 'from' && message.userName === 'STAY Bot')}">
        <img v-if="message.fromTo === 'from' && message.userName === 'STAY Bot'" src="@/assets/img/ico_talk_bot.png" class="icoBot" alt="">
        <img v-else :src="thumb(sender)" class="icoDefault" alt="">
      </div>
    </div>
    <div class="card"
      :class="{img: message.img}">
      <SetLink
        v-if="message.link && message.linkActive"
        :linkTarget="message.link"
        :lang="lang"
        :class="{notranslate: notranslate(message)}"
        class="cardLink" />
      <!-- response카드에 썸네일 업로드가 있는 경우 -->
      <div v-if="message.img" class="cardThumb notranslate">
        <img :src="message.img" alt="" @click="imgView($event, message.img)" />
      </div>
      <!-- //response카드에 썸네일 업로드가 있는 경우 -->
      <!-- 메시지 전송을 통해 이미지 업로드가 있는 경우 -->
      <div v-if="message.msgType === 'image'" class="inner notranslate" data-type="image">
        <img :src="message.message" alt="" @click="imgView($event, message.message)">
      </div>
      <!-- //메시지 전송을 통해 이미지 업로드가 있는 경우 -->
      <!-- 메시지 전송을 통해 동영상 업로드가 있는 경우 -->
      <div v-else-if="message.msgType === 'video'" class="inner notranslate" data-type="video">
        <div class="videoThumb" @click="videoView($event, message.message)">
          <img :src="message.thumbnail" alt="">
        </div>
      </div>
      <!-- //메시지 전송을 통해 동영상 업로드가 있는 경우 -->
      <div v-else class="inner">
        <div :class="{notranslate: notranslate(message)}">{{message.message}}</div>
        <div v-if="fromUser && isTranslate && (message.translatedText || updateTranslateText)" class="trsl">
          <p class="translateByText"><img src="@/assets/img/ico_google_translate.png" class="translateBy" alt="">{{locale.translate_by_google}}</p>
          <div class="notranslate">{{message.translatedText || updateTranslateText}}</div>
        </div>
      </div>
    </div>
    <div v-if="message.disconnect" class="disconnect notranslate">
      <button type="button" @click="reSend">{{locale.resend}}</button>
      <button type="button" @click="delDisconnect">{{locale.delete}}</button>
    </div>
    <div v-if="!message.disconnect" class="time notranslate">{{createat}}</div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import moment from 'moment/moment'
import SetLink from '@/components/Util/SetLink.vue'

export default {
  props: [
    'locale',
    'lang',
    'cid',
    'message',
    'sender',
    'isTranslate'
  ],
  components: {
    SetLink
  },
  computed: {
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    createat () {
      const time = DateTime.fromISO(this.message.createat || moment().toISOString(), { zone: this.timezone })
      return moment(this.message.createat).isSame(moment(), 'day')
        ? moment(this.message.createat).format('HH:mm') // 전송시간
        : time.toFormat(this.format) // 현재시간
    },
    fromUser () {
      const from = this.message.fromTo === 'from'
      const bot = from && this.message.userName === 'STAY Bot'
      const tag = this.message.msgType === 'tag'
      return from && !bot && !tag
    },
    customThumb () {
      return this.sender && this.sender.includes('https://')
    }
  },
  created () {
    const msg = this.message
    const lang = this.lang
    // 번역이 되지 않은 메시지가 있는 경우
    if (this.isTranslate && msg.fromTo === 'from' && msg.msgType === 'text' && !msg.translatedText) {
      const translateData = {
        msgId: msg.msgId,
        text: msg.message,
        to: lang
      }
      this.$store.dispatch('talk/getTranslate', translateData).then((res) => {
        const translateText = res && res.status === 200 && res.message
        if (translateText) {
          this.updateTranslateText = translateText.text
        }
      })
    }
  },
  data () {
    return {
      updateTranslateText: null
    }
  },
  methods: {
    notranslate (message) {
      const bot = message.fromTo === 'from' && message.userName === 'STAY Bot'
      const tag = message.fromTo === 'to' && message.msgType === 'tag'
      return !bot && !tag
    },
    imgView (e, src) {
      // const imgsrc = encodeURIComponent(src)
      // const url = `${window.location.href}/imageViewer/${imgsrc}`
      // e.stopPropagation()
      // window.open(url, '_blank')
      e.stopPropagation()
      this.$store.commit('setImgSrc', src)
    },
    videoView (e, src) {
      e.stopPropagation()
      this.$store.commit('setVideoSrc', src)
    },
    closeVideoView () {
      this.videoSrc = null
    },
    thumb (thumb) {
      const isCustom = this.customThumb
      let src = 'ico_talk_user'
      if (thumb === '1' || thumb === '2') {
        src += `_${thumb}.png`
      } else if (isCustom) {
        src = thumb
      } else {
        src = `${src}.png`
      }
      return isCustom ? src : require(`@/assets/img/${src}`)
    },
    reSend () {
      const data = {
        cid: this.cid,
        msgId: this.message.msgId,
        content: this.message.message,
        userName: this.message.userName,
        disconnect: this.message.disconnect
      }
      this.$emit('reSend', data)
    },
    delDisconnect () {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$emit('delDisconnect', this.message.msgId)
      }
    }
  }
}
</script>
